import { Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import Button from "@/common/elements/Button";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { useFilterSearchContext } from "@/contexts/FolderSearchContext";

const FolderDetailSearchActions = ({
  onCancel,
  onSearch,
  onSelectCurrentJacket,
  onCreateNewJacket,
  isDisabledCurrentJacket,
  onSearchIris,
  irisDeviceConnected,
}) => {
  const { requestFilter } = useFilterSearchContext();
  return (
    <StyledGridRow gutter={16} justify="start">
      <StyledGridCol marginTop="10px">
        <Button type="default" color="default" onClick={onCancel}>
          Cancel
        </Button>
      </StyledGridCol>
      <StyledGridCol marginTop="10px">
        <Button type="default" color="default" onClick={onSearch}>
          Search
        </Button>
      </StyledGridCol>
      <StyledGridCol marginTop="10px">
        <Button
          type="default"
          color="default"
          onClick={onSelectCurrentJacket}
          disabled={isDisabledCurrentJacket}
        >
          Select Current Folder
        </Button>
      </StyledGridCol>
      <StyledGridCol marginTop="10px">
        <Button
          type="default"
          color="default"
          onClick={onCreateNewJacket}
          disabled={requestFilter?.length === 0}
        >
          Create New Folder
        </Button>
      </StyledGridCol>
      {onSearchIris && (
        <StyledGridCol marginTop="10px">
          <Tooltip
            title={
              irisDeviceConnected
                ? null
                : "Connect an iris device to enable the iris search button."
            }
          >
            <Button
              type="default"
              color="default"
              onClick={onSearchIris}
              icon={<EyeOutlined />}
              disabled={!irisDeviceConnected}
            >
              Search Iris
            </Button>
          </Tooltip>
        </StyledGridCol>
      )}
    </StyledGridRow>
  );
};

export default FolderDetailSearchActions;
